import React from 'react';
import { useQuery } from '@apollo/client';
import { AllQuizzQuery } from 'graphql/generated/graphql';
import GET_ALL_AVAILABLE_QUIZ from 'graphql/query/quiz/allQuiz';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { MobileTabLineQuiz } from 'components/molecules/Table/MobileTabLine/MobileTabLineQuiz';

export interface MobileTabQuizProps {
  eleves?: ElevesDashboardProf[];
}

export const MobileTabQuiz = ({ eleves }: MobileTabQuizProps) => {
  const { loading, error, data } = useQuery<AllQuizzQuery>(
    GET_ALL_AVAILABLE_QUIZ
  );

  if (loading) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError(
            'Erreur dans la récupération des données (classe ou Quiz)'
          )
        }
        needCaptureError={false}
      />
    );

  if (!data.availableQuiz) return null;
  return <MobileTabLineQuiz eleves={eleves} data={data} />;
};
